<template>
  <div class="form-group col-8 u-inline-flex">
    <input
      type="search"
      placeholder="Search"
      v-bind:value="search"
      v-on:input="$emit('handleSearch', $event.target.value)"
    />
    <button
      class="clear-search form-group-btn"
      v-on:click="$emit('handleSearch', '')"
    >
      <i class="fas fa-wrapper fa-times-circle"></i>
    </button>
  </div>
</template>
<style>
.clear-search {
  font-size: 150%;
}
</style>
<script>
export default {
  name: "search-field",
  props: ["search"]
};
</script>
